var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M6.80142 40.8085C6.80142 59.5901 22.0269 74.8156 40.8085 74.8156C59.5901 74.8156 74.8156 59.5901 74.8156 40.8085C74.8156 22.0269 59.5901 6.80142 40.8085 6.80142C22.0269 6.80142 6.80142 22.0269 6.80142 40.8085Z",
    fill: "#FA756D",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6097 32.6097C28.2541 36.9652 27.3019 47.2875 27.3019 47.2875C26.7169 52.8504 28.7666 54.9001 34.3295 54.3151C34.3295 54.3151 44.6518 53.3629 49.0074 49.0073C53.3629 44.6518 54.3151 34.3295 54.3151 34.3295C54.9001 28.7666 52.8504 26.7169 47.2875 27.3019C47.2875 27.3019 36.9653 28.2541 32.6097 32.6097ZM37.4078 40.8085C37.4078 42.6867 38.9304 44.2092 40.8085 44.2092C42.6867 44.2092 44.2092 42.6867 44.2092 40.8085V40.8051C44.2092 38.9269 42.6867 37.4044 40.8085 37.4044C38.9304 37.4044 37.4078 38.9269 37.4078 40.8051V40.8085Z",
    fill: "#FA756D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/MobileLogo.ea88737e29ed9067a0f5d25edcef2965.svg";
export { ForwardRef as ReactComponent };